export default __webpack_public_path__ + "static/media/avatar4.1f8958bd.svg";